import { isInternalPath, webPaths } from "@zplanem/web-paths"
import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { useAuth } from "../auth-context"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"

export function AuthPage() {
	const { user, loginWithGoogle, loading } = useAuth()
	const { locale } = useLocale()
	const navigate = useNavigate()
	const [params] = useSearchParams()
	const t = getTranslations(locale)

	useEffect(() => {
		if (user && !loading) {
			const next = params.get("next")
			const safeNext =
				next && isInternalPath(next) ? next : webPaths.dashboard()
			navigate(safeNext, { replace: true })
		}
	}, [user, loading, navigate, params])

	if (loading) return null

	return (
		<div className="relative min-h-screen w-full flex items-center justify-center bg-background px-4 overflow-x-hidden">
			<div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-primary/5 blur-[100px] rounded-full pointer-events-none" />

			<div className="relative w-full max-w-md bg-muted/40 backdrop-blur-2xl p-8 md:p-12 rounded-[32px] border border-border shadow-2xl text-center">
				<h1 className="text-4xl font-black text-foreground mb-2">
					{t.auth.login}
				</h1>
				<p className="text-muted-foreground mb-10 font-medium">
					{t.dashboard.welcome}
				</p>

				<div className="flex flex-col gap-4">
					<Button
						onClick={loginWithGoogle}
						variant="outline"
						className="w-full h-14 rounded-lg bg-white text-black hover:bg-gray-100 hover:text-black border-none font-bold text-base shadow-lg"
					>
						{/* Google Icon could go here */}
						{t.auth.googleLogin}
					</Button>

					<Button
						variant="ghost"
						onClick={() => navigate(webPaths.landing())}
						className="mt-4 text-muted-foreground/80 hover:text-foreground back-btn"
					>
						← {t.auth.backToMain}
					</Button>
				</div>
			</div>
		</div>
	)
}
